import { Grid, TextField } from '@mui/material';
import { createCustomerPageSelectors, getSelectorAttribute } from '@vy/app-selectors';
import type { NewCustomer, UpdateCustomer } from '@vy/types';
import { isNotNullOrUndefined } from '@vy/utils';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { CountriesDropDown } from '../../../../../../components/design/dropdowns/CountriesDropDown';
import { vyFormRegister } from '../../../../../../utils/react-hook-forms-utils';
import type { CreateCustomerMode } from '../../../create-customer-page-types/CreateCustomerModeType';
import { VyIcon } from '@vy/ui-design-system';
import { colors } from '../../../../../../assets/themes/colors.ts';
import { VyFormSection } from '../../../../../../components/design/layout';

export const CreateCustomerAddressSection: React.FC<CreateCustomerMode> = ({ mode: _mode = 'create' }) => {
  const { getValues, register, formState } =
    useFormContext<typeof _mode extends 'create' ? NewCustomer : UpdateCustomer>();

  return (
    <VyFormSection
      title="Address"
      icon={<VyIcon icon="AddressBookEmail" height={18} width={18} color={colors.grey[90]} />}
    >
      <Grid container rowSpacing={3} columnSpacing={2}>
        <Grid size={4}>
          <CountriesDropDown defaultSelectedCountry={getValues('address.country')} />
        </Grid>

        <Grid size={4}>
          <TextField
            {...getSelectorAttribute(createCustomerPageSelectors.companyDetails.state)}
            label="State"
            placeholder="e.g New York"
            fullWidth
            defaultValue={getValues('address.state')}
            error={isNotNullOrUndefined(formState.errors.address?.state)}
            helperText={formState.errors.address?.state?.message}
            {...vyFormRegister(register, 'address.state')}
          />
        </Grid>

        <Grid size={4}>
          <TextField
            {...getSelectorAttribute(createCustomerPageSelectors.companyDetails.city)}
            label="City"
            placeholder="e.g New York"
            fullWidth
            defaultValue={getValues('address.city')}
            error={isNotNullOrUndefined(formState.errors.address?.city)}
            helperText={formState.errors.address?.city?.message}
            {...vyFormRegister(register, 'address.city')}
          />
        </Grid>

        <Grid size={4}>
          <TextField
            {...getSelectorAttribute(createCustomerPageSelectors.companyDetails.address)}
            label="Address"
            placeholder="e.g 123 Main St"
            fullWidth
            defaultValue={getValues('address.addressText')}
            error={isNotNullOrUndefined(formState.errors.address?.addressText)}
            helperText={formState.errors.address?.addressText?.message}
            {...vyFormRegister(register, 'address.addressText')}
          />
        </Grid>

        <Grid size={4}>
          <TextField
            {...getSelectorAttribute(createCustomerPageSelectors.companyDetails.postalCode)}
            label="Postal Code"
            placeholder="e.g 12345"
            fullWidth
            defaultValue={getValues('address.postalCode')}
            error={isNotNullOrUndefined(formState.errors.address?.postalCode)}
            helperText={formState.errors.address?.postalCode?.message}
            {...vyFormRegister(register, 'address.postalCode')}
          />
        </Grid>
      </Grid>
    </VyFormSection>
  );
};
